import React, {useEffect, useState, useRef} from 'react';
import './TestActivity.sass';
import PieGraph from "../../ui/PieGraph/PieGraph";
import videojs from 'video.js'
import apiJSON from "../../../api/apiJSON";
import VideoJS from "../../ui/Video/VideoJS";

const TestActivity = ({data}) => {
    const jsonData = apiJSON.get(data);
    const playerRef = useRef(null);

    useEffect(() => {

    }, []);

    const onPlayerReady = () =>{
        console.log("TestActivity onPlayerReady(",playerRef.current,")");
    }

    return (
        <div className="TestActivity">
            <VideoJS src={jsonData.video.options.source.src} minimal={true} ref={playerRef} style={{
                height: "100%",
                width: "100%"
            }}/>
        </div>
    );
};

export default TestActivity;